@if (control) {
  <section [matTooltip]="matTooltip | translate" class="checkbox-section">
    @if (hasPermission) {
      <mat-checkbox [aria-label]="label | translate" [formControl]="control" [required]="required">
        <span class="ui-selection-label">
          {{ label | translate }}
          @if (required) {
            <span class="required-marker" aria-hidden="true">*</span>
          }
        </span>
      </mat-checkbox>
    } @else {
      <mat-checkbox
        [aria-label]="label | translate"
        [checked]="control.value"
        [required]="required"
        disabled
      >
        <span class="ui-selection-label">
          {{ label | translate }}
          @if (required) {
            <span class="required-marker" aria-hidden="true">*</span>
          }
        </span>
      </mat-checkbox>
    }
  </section>
  @if (required && control.invalid && (control.touched || control.dirty)) {
    <mat-error>{{ 'required' | translate }}</mat-error>
  }
}
